@let activeTab = tabs.activeTab();
@let editor = tabs.editor();

<div class="relative flex h-[min(33.75rem,85vh)] w-full flex-col overflow-hidden max-md:!h-dvh max-sm:overflow-auto">
  <gc-dialog-event-header class="shrink-0"
                          [title]="title"
                          (closeRequested)="requestClose()"></gc-dialog-event-header>

  @switch (editor) {
    @case (Editor.Status) {
      <gc-dialog-event-change-form class="flex-1 min-h-0"></gc-dialog-event-change-form>
    }

    @case (Editor.Result) {
      <gc-dialog-event-change-form class="flex-1 min-h-0"></gc-dialog-event-change-form>
    }

    @case (Editor.Location) {
      <gc-dialog-event-location-edit class="flex-1 min-h-0"></gc-dialog-event-location-edit>
    }

    @default {
      @if (dialogState.isCreating()) {
        <gc-dialog-event-create class="flex-1 min-h-0"
                                (created)="closeCreated()"
                                (cancelled)="requestClose()"></gc-dialog-event-create>
      } @else {
        <div class="flex shrink-0 items-center gap-[0.375rem] px-[1.25rem] pb-[0.5rem]">
          @for (tab of tabOrder; track tab) {
            @let isActive = activeTab === tab;

            <p-button severity="secondary"
                      [styleClass]="'!gap-[0.25rem] !rounded-[0.25rem] !border !px-[0.6875rem] !py-[0.3125rem] !text-[0.6875rem] !font-medium !leading-[150%] ' +
                        (isActive
                          ? '!border-(--p-blue-500) !bg-(--p-blue-500) !text-(--p-surface-0) hover:!border-(--p-blue-600) hover:!bg-(--p-blue-600)'
                          : '!border-(--p-neutral-500) !bg-(--p-neutral-500) !text-(--p-blue-600) hover:!border-(--p-blue-100)')"
                      (onClick)="tabs.activeTab.set(tab)">
              <span [translate]="tabLabels[tab]"></span>

              @if (tab === EventTabs.History) {
                <span>({{ historyCount() }})</span>
              }
            </p-button>
          }
        </div>

        <div class="flex-1 min-h-0 overflow-auto">
          @switch (activeTab) {
            @case (EventTabs.Details) {
              <gc-dialog-event-details></gc-dialog-event-details>
            }
            @case (EventTabs.History) {
              <gc-dialog-event-history class="h-full"></gc-dialog-event-history>
            }
          }
        </div>

        @if (activeTab === EventTabs.Details) {
          <gc-dialog-event-status-bar class="shrink-0"></gc-dialog-event-status-bar>

          <gc-dialog-event-footer class="shrink-0"></gc-dialog-event-footer>
        }
      }
    }
  }

  @if (tabs.overlay(); as overlay) {
    <gc-dialog-event-confirm-overlay [overlay]="overlay"
                                     (confirmed)="confirmOverlay(overlay)"
                                     (cancelled)="tabs.closeOverlay()"></gc-dialog-event-confirm-overlay>
  }
</div>
